// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"08d9495d","425":"66cadb8b","510":"3c5c4f1d","532":"414d80e7","633":"90d02aa9","634":"0056677f","922":"69e9ef58","937":"b3f9e07a","972":"ee58d9cf"}[chunkId] + ".chunk.js";
};